export default "__VITE_ASSET__qo7R4wQa__"